import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import {
  UserProfile,
  UserRole,
  InviteResponse,
  UserCustomRoleResponse,
  UserProfileResponseTypes,
  FeatureFlagManageResponse,
  UpdateFeatureFlagRolesRequest,
  UpdateFeatureFlagRolesResponse,
} from '@app/types'
import { logger } from '@app/utils/logger'

const AdminService = {
  getPostLoginUserProfile: async (): Promise<UserProfileResponseTypes> => {
    try {
      return await apiClient.get(Endpoint.PostLoginUserProfile)
    } catch (error) {
      logger.error('Error getting post login user profile:', error)
      throw error
    }
  },

  getClientUsers: async (): Promise<UserProfile[]> => {
    try {
      const response = await apiClient.get(Endpoint.getClientUsers)
      return response.data
    } catch (error) {
      logger.error('Error fetching users:', error)
      throw error
    }
  },

  getEmailDomains: async (): Promise<string[]> => {
    try {
      const response = await apiClient.get(Endpoint.clientEmailDomains)
      return response.data
    } catch (error) {
      logger.error('Error fetching email domains:', error)
      throw error
    }
  },

  inviteUsers: async (
    emails: string[],
    clientName: string,
    roles: UserRole[],
  ): Promise<InviteResponse> => {
    try {
      const response = await apiClient.post<InviteResponse>(Endpoint.userInvite, {
        emails_to_invite: emails,
        client_name: clientName,
        user_roles: roles,
      })
      return response.data
    } catch (error) {
      logger.error('Error inviting users:', error)
      throw error
    }
  },

  updateUserRole: async (
    uuid: string,
    clientName: string,
    roles: UserRole[],
  ): Promise<InviteResponse> => {
    try {
      const response = await apiClient.post<InviteResponse>(Endpoint.updateUserRole, {
        uuid,
        client_name: clientName,
        user_roles: roles,
      })
      return response.data
    } catch (error) {
      logger.error('Error updating user roles:', error)
      throw error
    }
  },

  deleteUser: async (user_uuid: string) => {
    try {
      const response = await apiClient.post(Endpoint.deleteUser, { user_uuid })
      return response.data
    } catch (error) {
      logger.error('Error deleting user:', error)
      throw error
    }
  },

  resendInvite: async (email: string) => {
    try {
      const response = await apiClient.post(Endpoint.resendInviteEmail, { email })
      return response.data
    } catch (error) {
      logger.error('Error resending invite:', error)
      throw error
    }
  },
}

export { AdminService }
